export function routes($stateProvider) {
  $stateProvider
    .state('app.revista', {
      url: '/revista',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.revista.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Revistas',
      template: require('./directory/directory.view.html'),
      controller: 'RevistaListController',
      controllerAs: 'vm',
      role: 'revistaRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.revista.details', {
      url: '/{id}',
      title: 'Revista',
      controller: 'RevistaDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'revistaRead'
    })
    .state('app.revista.new', {
      url: '/nova',
      title: 'Adicionar Revista',
      template: require('./new/new.view.html'),
      controller: 'RevistaCreateRevistaController',
      controllerAs: 'vm',
      role: 'revistaCreate'
    })
    .state('app.revista.new.1', {
      template: require('./new/revista.1.form.html')
    })
    .state('app.revista.new.2', {
      template: require('./new/revista.2.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
